import React from 'react'
import styled from 'styled-components'

import CMS from '@talus-analytics/library.airtable-cms'
import useIndexPageData from '../../../cmsHooks/useIndexPageData'

import { Center } from '../../layout'
import { FormLabel, FormTextInput } from '../../ui'
import EmailerForm from '../../misc/EmailerForm'
import device from '../../../utilities/device'
import getFormLabel from './learn/getFormLabel'

import { FullWidthSection, ContentContainer } from '../../layout'

const ShadowBox = styled.div`
  border-radius: 3px;
  padding: 50px;
  background-color: ${({ theme }) => theme.colorWhite};
  color: ${({ theme }) => theme.colorVeryDarkGray};
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colorLime};
  box-shadow: 1px 1px 5px 0 rgba(0, 0, 0, 0.25);

  @media ${device.laptop} {
    margin: 50px;
    padding: 50px;
    max-width: 80%;
    box-sizing: border-box;
    p {
      font-size: 20px;
      line-height: 1.4em;
    }
  }
  @media ${device.mobileL} {
    margin: 50px auto;
    padding: 30px;
    max-width: 90%;
    p {
      font-size: 18px;
    }
  }
  @media ${device.mobileM} {
    max-width: 98%;
  }
`

const DemoHeading = styled.h3`
  color: ${({ theme }) => theme.colorLime};
  text-align: center;
  @media ${device.laptop} {
    margin-bottom: 15px;
  }
`

const LearnMoreHeadline = styled.h2`
  margin-bottom: 60px;
  @media ${device.laptop} {
    margin-bottom: 30px;
  }
`
const LearnMore = styled.div`
  margin-bottom: 60px;
  @media ${device.laptop} {
    margin-bottom: 30px;
  }
`
const LearnMoreHeader = styled.h3`
  color: ${({ theme }) => theme.colorMedBlue};
  margin-bottom: 15px;
`
const FormFields = styled.div`
  margin-bottom: 50px;
`
const MaxWidth = styled.div`
  max-width: 690px;
`
const Spacer = styled.div`
  height: 50px;
  @media ${device.laptop} {
    height: 25px;
  }
`

const DemoSection = (): JSX.Element => {
  const data = useIndexPageData()

  return (
    <FullWidthSection>
      <ContentContainer>
        <Center cross>
          <MaxWidth>
            <Center cross>
              <LearnMoreHeadline>
                <CMS.Text name="Learn more headline" data={data} />
              </LearnMoreHeadline>
              <LearnMore>
                <LearnMoreHeader>
                  <CMS.Text name="Learn 1 tagline" data={data} />
                </LearnMoreHeader>
                <p>
                  <CMS.Text name="Learn 1 description" data={data} />
                </p>
              </LearnMore>
              <LearnMore>
                <LearnMoreHeader>
                  <CMS.Text name="Learn 2 tagline" data={data} />
                </LearnMoreHeader>
                <p>
                  <CMS.Text name="Learn 2 description" data={data} />
                </p>
              </LearnMore>
              <ShadowBox>
                <DemoHeading>
                  <CMS.Text name="Form headline" data={data} />
                </DemoHeading>
                <EmailerForm
                  {...{
                    subjectCMSName: 'Demo subject',
                    siteCMSName: 'Site name',
                    bodyCMSName: 'Demo body',
                    buttonTextCMSName: 'Demo button',
                    submittingButtonTextCMSName: 'In-progress button text',
                    successMessageCMSName: 'Demo success text',
                    errorMessageCMSName: 'Error text',
                    submitUrlCMSName: 'Submit URL',
                    formAriaLabelCMSName: 'Demo aria label',
                  }}
                >
                  <FormFields>
                    <FormLabel>
                      {getFormLabel(CMS.getText(data, 'Email label'))}
                      <FormTextInput
                        type="email"
                        name="Email address"
                        required
                      />
                    </FormLabel>
                    <Spacer />
                    <FormLabel>
                      {getFormLabel(CMS.getText(data, 'Link label'))}
                      <FormTextInput
                        type="text"
                        name="Link to existing data inventory or library"
                      />
                    </FormLabel>
                  </FormFields>
                </EmailerForm>
              </ShadowBox>
            </Center>
          </MaxWidth>
        </Center>
      </ContentContainer>
    </FullWidthSection>
  )
}

export default DemoSection
